import { pxToRem } from 'modules/spacing';
const none = '0';
const xs = pxToRem(4);
const sm = pxToRem(6);
const md = pxToRem(8);
const lg = pxToRem(14);
const circle = '50%';
export const borderRadius = {
    none,
    xs,
    sm,
    md,
    lg,
    circle,
};
